import { Navigate, useLocation, type RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

// Раздел «Телоскоп»: графики, таблицы и цели. Вкладки объявляют сами экраны (metrics, goals)
// с parent: '/teloscope'; голый /teloscope ведёт на первую — «Показатели».

/** Старые адреса /metrics и /goals ведут во вкладки раздела, сохраняя ?new=1&kind=… и т. п. */
function MovedTo({ to }: { to: string }) {
  const { search } = useLocation()
  return <Navigate to={`${to}${search}`} replace />
}

export const routes: RouteObject[] = [
  { path: '/metrics', element: <MovedTo to="/teloscope/metrics" /> },
  { path: '/goals', element: <MovedTo to="/teloscope/goals" /> },
]

export const nav: NavItem[] = [{ path: '/teloscope', label: 'Телоскоп', icon: 'chart', mobile: 'more', order: 50 }]
